import React, { useCallback, useMemo } from 'react';
import { useTranslation }              from 'react-i18next';
import { useLocation }                 from 'react-router-dom';

import './style.scss';

import { useCatalog }     from '../../providers/catalog';
import { useNews }        from '../../providers/news';
import { usePromotions }  from '../../providers/promotions';
import { useWhereBuy }    from '../../providers/whereBuy';
import { BreadcrumbItem } from './components';

const Breadcrumbs = function() {
  const {
          catalog: { meta: { titleH1 } },
          element: { models },
        }                                      = useCatalog();
  const {
          pathname,
          state,
        }                                      = useLocation();
  const { article: { label: newsTitle } }      = useNews();
  const { article: { label: promotionTitle } } = usePromotions();
  const { t }                                  = useTranslation();
  const {
          regions,
          cities,
        }                                      = useWhereBuy();

  const titleDoor = useMemo(() => {
    for (const modelId in models) {
      let model = models[modelId];

      for (const seriesId in model) {
        let series = model[seriesId];

        for (const offerId in series) {
          let {
                common: {
                          urlKey,
                          label,
                        },
              } = series[offerId];

          if (urlKey === pathname) {
            return label;
          }
        }
      }
    }
  }, [models, pathname]);

  const getTitle = useCallback((firstLevel, secondLevel) => {
    switch (firstLevel) {
      case 'vhodnye-dveri':
      case 'mezhkomnatnye-dveri':
        return new RegExp(`^${DOOR_PREFIX}`).test(secondLevel) ? titleDoor : titleH1;
      case 'novosti':
        return newsTitle;
      case 'akcii':
        return promotionTitle;
      case 'gde-kupit-kontakty':
        return (
          [...regions, ...cities].find((item) => item.urlKey === secondLevel) || {}).label;
      default:
        return null;
    }
  }, [
    cities,
    newsTitle,
    promotionTitle,
    regions,
    titleDoor,
    titleH1,
  ]);

  const breadcrumbs = React.useMemo(() => {
    const [, firstLevel, secondLevel] = pathname.split('/');

    const crumbs = [
      {
        title: t('breadcrumb.main'),
      },
    ];

    if (firstLevel) {
      const [label] = firstLevel.split('.');

      if (secondLevel) {
        if (state?.prevUrl) {
          crumbs.push(
            {
              title: t(`breadcrumb.${label}`),
              url:   firstLevel,
            },
            {
              title:  state.title,
              url:    `${firstLevel}/${state.prevUrl}`,
              search: state?.search || '',
            },
            {
              title: getTitle(firstLevel, secondLevel),
              url:   pathname,
            },
          );
        } else {
          crumbs.push(
            {
              title:  t(`breadcrumb.${label}`),
              url:    `${firstLevel}`,
              search: state?.search || '',
            },
            {
              title: getTitle(firstLevel, secondLevel),
              url:   pathname,
            },
          );
        }
      } else {
        crumbs.push({
          title: t(`breadcrumb.${label}`),
          url:   pathname,
        });
      }
    }

    return crumbs;
  }, [pathname, getTitle, state?.search, state?.prevUrl]);

  const isFrontPage = useMemo(() => pathname === '/', [pathname]);

  if (isFrontPage) {
    return null;
  }

  return (
    <div className={'breadcrumbs'}>
      <ol
        itemScope
        itemType={'https://schema.org/BreadcrumbList'}
      >
        {breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;

          return (
            <BreadcrumbItem
              isLast={isLast}
              key={index}
              position={index + 1}
              {...crumb}
            />
          );
        })}
      </ol>
    </div>
  );
};

export default Breadcrumbs;